<template>
  <Dropdown
    :style="{width: '100%', position: 'relative'}"
    :visible="visible"
    class="customDrop"
    ref="bussinessTypeDropRef"
    trigger="custom"
  >
    <Input
      :icon="visible?'ios-arrow-up':'ios-arrow-down'"
      :placeholder="placeholder"
      @on-clear="clear"
      @on-click="handleOpen"
      @on-focus="handleOpen"
      readonly
      v-model="bussinessTypeName"
    ></Input>
    <DropdownMenu slot="list">
      <div class="treePanel">
        <div class="treeContainer">
          <Tree
            :check-strictly="true"
            :data="bussinessTypeTree"
            :multiple="multiple=='1'?true:false"
            :render="renderContent"
            @on-select-change="changeSelectNode"
            class="bussinessTypeTree"
            ref="typeTree"
          ></Tree>
        </div>
      </div>
    </DropdownMenu>
  </Dropdown>
</template>
<script>
export default {
  name: 'bussinessType',
  props: {
    value: {
      type: String
    },
    placeholder: {
      required: false,
      default: '请选择业务类型'
    },
    coreId: {
      type: String,
      default: 'app'
    },
    multiple: {
      required: false,
      type: String,
      default: 1
    }
  },
  watch: {
    value: {
      handler (val) {
        this.chks = val
        this.dealTreeData()
      },
      immediate: true
    }
  },
  data () {
    return {
      visible: false,
      bussinessTypeId: null,
      bussinessTypeName: '',
      bussinessTypeTree: [],
      current: null,
      chks: ''
    }
  },
  methods: {
    changeSelectNode: function (checked, current) {
      this.current = current
      this.chks = current.id
      this.bussinessTypeId = current.id + ''
      this.bussinessTypeName = current.name
      this.$emit('change', this.bussinessTypeId + '')
      this.$emit('changeSelectNode', { checked: checked.length > 0, node: current })
    },
    close: function () {
      this.visible = false
      this.chks = ''
      this.bussinessTypeId = ''
      this.bussinessTypeName = ''
    },
    handleOpen: function () {
      this.visible = !this.visible
    },
    clear: function () {
      this.close()
    },
    outClick (e) {
      let bussinessTypeDropRef = this.$refs.bussinessTypeDropRef.$el
      let typeTree = this.$refs.typeTree.$el
      if (!typeTree.contains(e.target) && !bussinessTypeDropRef.contains(e.target) && this.visible) {
        this.visible = false
      }
    },
    traverseTree: function (nodes, chkNames) {
      if (nodes === null || nodes === undefined || nodes.length === 0) return
      for (let i = 0; i < nodes.length; i++) {
        if (this.chks == nodes[i].id) {
          this.$set(nodes[i], 'selected', true)
          chkNames.push(nodes[i].name)
        } else {
          this.$set(nodes[i], 'selected', false)
        }
        this.traverseTree(nodes[i].children, chkNames)
      }
    },
    dealTreeData: function () {
      let nameArr = []
      if (this.chks?.length > 0) {
        this.traverseTree(this.bussinessTypeTree, nameArr)
      }
      this.bussinessTypeName = nameArr.join('，')
      console.log(this.bussinessTypeName, 'this.bussinessTypeName')
    },
    initBussinessTypeTree: async function () {
      let that = this
      that.bussinessTypeTree = await this.$baseData.handleData(false, that.$apis.ICHLApi.bussinessType.bussinessTypeTree, null) || []
      that.dealTreeData()

      // this.bussinessTypeTree = []
      // this.$axios.post(that.$apis.ICHLApi.bussinessType.bussinessTypeTree).then(res => {
      //   if (res.success) {
      //     that.bussinessTypeTree = res.result || []
      //     that.dealTreeData()
      //   } else {
      //     that.$Message.error(res.message)
      //   }
      // }).catch(function (err) {
      //   that.$Message.error("获取业务类型失败！")
      // })
    },
    renderContent (h, { root, node, data }) {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, [
        h('span', {
          style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        }, [
          h('span', data.name)
        ]),
        h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
            marginRight: '1.2rem'
          }
        }, [
        ])
      ])
    },
  },
  beforeMount () {
    this.chks = this.value
    this.initBussinessTypeTree()
    document.body.addEventListener('click', this.outClick)
  },
  beforeDestroy () {
    this.close()
    document.body.removeEventListener('click', this.outClick)
  }
}
</script>

<style scoped>
.treePanel {
  padding: 0 1rem;
  max-width: 600px;
}
</style>
